module.exports = __webpack_public_path__ + "static/media/WBNB.34f97f01.svg";